var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _g, _path14, _path15, _path16, _ellipse, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonsterHandsUp0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 147,
    viewBox: "0 0 173 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1834 38.3728C3.66293 4.02041 21.256 5.14249 23.3812 6.42282C23.3812 6.42282 31.5769 -1.06398 34.345 7.66711C34.5305 8.28701 34.6937 8.81728 34.8422 9.28782C34.7454 9.15328 34.7007 9.10095 34.7007 9.10095C34.7007 9.10095 36.7716 15.4048 34.8422 9.28782C35.6019 10.1775 38.8267 14.2292 38.261 17.3184C37.605 20.8106 30.0796 21.1551 30.0796 21.1551C30.0796 21.1551 22.2318 58.0453 50.5372 95.0689C50.5372 95.0689 20.6964 72.6953 12.1834 38.3728Z",
    fill: "url(#paint0_linear_14011_164658)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M95.839 120.171C97.5027 124.206 95.1696 139.026 94.1943 144.744C93.9839 145.929 94.8828 147 96.0876 147H104.005C106.491 147 106.625 143.29 104.139 143.137C103.795 143.118 103.469 143.099 103.144 143.099C101.481 143.08 100.62 141.149 101.691 139.886C108.097 132.39 111.999 122.409 113.165 119.177C113.51 118.202 113.031 117.131 112.075 116.729C110.66 116.156 108.384 115.869 105.975 115.869C100.639 115.869 94.6533 117.284 95.839 120.171Z",
    fill: "url(#paint1_linear_14011_164658)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.587 120.733C112.826 120.117 113.021 119.591 113.17 119.177C113.515 118.202 113.037 117.131 112.08 116.729C110.665 116.155 108.389 115.869 105.98 115.869C100.644 115.869 94.6585 117.284 95.8442 120.171C96.2305 121.108 96.4013 122.627 96.4237 124.478C102.565 123.639 107.928 122.365 112.587 120.733Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8359 116.729C55.8797 117.13 55.4016 118.201 55.7458 119.176C56.9124 122.408 60.8138 132.39 67.2204 139.886C68.2914 141.148 67.4308 143.08 65.767 143.099C65.4419 143.099 65.1167 143.118 64.7725 143.137C62.2863 143.29 62.4202 147 64.9064 147H72.8239C74.0287 147 74.9275 145.929 74.7172 144.744C73.7418 139.026 71.4087 124.206 73.0725 120.171C74.2582 117.283 68.2723 115.868 62.9366 115.868C60.5269 115.868 58.2511 116.155 56.8359 116.729Z",
    fill: "url(#paint2_linear_14011_164658)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4858 125.171C72.4712 123.007 72.6334 121.222 73.067 120.171C74.2527 117.283 68.2668 115.868 62.9311 115.868C60.5214 115.868 58.2457 116.155 56.8305 116.729C55.8742 117.13 55.3961 118.201 55.7404 119.176C55.9645 119.797 56.2895 120.667 56.7139 121.721C61.2125 123.399 66.4365 124.598 72.4858 125.171Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M141.452 19.1551C141.452 19.1551 133.926 18.8109 133.27 15.3187C132.704 12.2295 135.929 8.1777 136.689 7.28801C134.76 13.405 136.83 7.10113 136.83 7.10113C136.83 7.10113 136.786 7.15347 136.689 7.28801C136.837 6.81747 137 6.28719 137.186 5.66729C139.954 -3.06387 148.15 4.42262 148.15 4.42262C150.275 3.14222 167.868 2.01951 159.349 36.3721C150.837 70.6948 120.997 93.0694 120.997 93.0694C149.301 56.0449 141.452 19.1551 141.452 19.1551Z",
    fill: "url(#paint3_linear_14011_164658)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M34.429 29.3742C31.7227 33.4931 32.8244 39.001 36.9197 41.7309C41.0389 44.437 53.6362 48.0051 56.3425 43.9101C59.0727 39.8152 50.8821 29.5897 46.7628 26.8837C45.254 25.8779 43.5536 25.399 41.8532 25.399C38.9793 25.399 36.1533 26.7879 34.429 29.3742Z",
    fill: "url(#paint4_linear_14011_164658)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1084 35.3083C35.1084 31.0287 37.1923 28.475 42.2462 28.4746C47.3001 28.4743 49.2084 34.7544 49.2084 37.4301C49.2084 40.7748 47.936 42.5371 43.4479 42.5371C38.9599 42.5371 35.1084 39.588 35.1084 35.3083Z",
    fill: "url(#paint5_linear_14011_164658)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M120.625 26.8837C116.506 29.5897 108.315 39.8152 111.045 43.9101C113.752 48.0051 126.349 44.437 130.468 41.7309C134.563 39.001 135.689 33.4931 132.959 29.3742C131.235 26.7879 128.409 25.399 125.535 25.399C123.834 25.399 122.134 25.8779 120.625 26.8837Z",
    fill: "url(#paint6_linear_14011_164658)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M132.475 35.3083C132.475 31.0287 130.391 28.4749 125.337 28.4746C120.283 28.4743 118.375 34.7543 118.375 37.4301C118.375 40.7748 119.647 42.5371 124.135 42.5371C128.624 42.5371 132.475 39.588 132.475 35.3083Z",
    fill: "url(#paint7_linear_14011_164658)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M85.14 29.4884C43.802 32.2077 40.4296 50.5907 33.7938 65.3841C27.5931 79.416 26.0701 128.038 89.709 123.035C153.348 118.031 144.21 71.2579 127.457 49.3942C112.989 30.6849 92.3198 29.3796 86.663 29.3796C85.6839 29.3796 85.14 29.4884 85.14 29.4884Z",
    fill: "url(#paint8_linear_14011_164658)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M136.158 69.6532C140.618 88.4709 133.547 101.089 122.234 110.878C110.921 120.559 73.826 127.412 49.2412 112.183C29.9867 100.11 31.9448 75.962 33.6853 65.6286C27.5935 79.9866 26.5057 128.064 89.7082 123.061C147.798 118.492 145.296 79.0077 131.589 55.6215C133.221 59.4286 134.853 64.1058 136.158 69.6532Z",
    fill: "url(#paint9_linear_14011_164658)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.202 31.4374C100.202 33.0061 98.9814 34.2777 97.4758 34.2777C95.9701 34.2777 94.7496 33.0061 94.7496 31.4374C94.7496 30.968 94.8589 30.5251 95.0525 30.135C96.6435 30.4079 98.3725 30.7764 100.197 31.2721C100.2 31.3268 100.202 31.382 100.202 31.4374ZM110.165 35.079C109.975 35.2374 109.854 35.4747 109.854 35.7399C109.854 36.2166 110.244 36.6031 110.725 36.6031C111.177 36.6031 111.548 36.2626 111.592 35.8265C111.115 35.5672 110.639 35.3181 110.165 35.079ZM66.7747 32.2339C67.5244 32.6079 68.0434 33.4163 68.0434 34.3535C68.0434 35.6462 67.0556 36.6943 65.8371 36.6943C64.6186 36.6943 63.6308 35.6462 63.6308 34.3535C63.6308 33.8512 63.7799 33.386 64.0336 33.0047C64.9163 32.7355 65.8295 32.4783 66.7747 32.2339ZM105.946 34.4586C105.946 35.0786 105.46 35.5812 104.861 35.5812C104.262 35.5812 103.777 35.0786 103.777 34.4586C103.777 33.8386 104.262 33.336 104.861 33.336C105.46 33.336 105.946 33.8386 105.946 34.4586ZM100.428 40.0486C101.072 40.0486 101.593 39.5086 101.593 38.8426C101.593 38.1765 101.072 37.6365 100.428 37.6365C99.7849 37.6365 99.2634 38.1765 99.2634 38.8426C99.2634 39.5086 99.7849 40.0486 100.428 40.0486ZM116.217 44.3587C117.458 44.3587 118.465 43.3163 118.465 42.0305C118.465 40.7447 117.458 39.7024 116.217 39.7024C114.975 39.7024 113.968 40.7447 113.968 42.0305C113.968 43.3163 114.975 44.3587 116.217 44.3587ZM113.633 47.351C113.633 47.9021 113.201 48.3489 112.669 48.3489C112.136 48.3489 111.705 47.9021 111.705 47.351C111.705 46.7999 112.136 46.3531 112.669 46.3531C113.201 46.3531 113.633 46.7999 113.633 47.351ZM117.991 49.4503C118.479 49.4503 118.875 49.0409 118.875 48.5358C118.875 48.0308 118.479 47.6213 117.991 47.6213C117.503 47.6213 117.107 48.0308 117.107 48.5358C117.107 49.0409 117.503 49.4503 117.991 49.4503ZM113.092 53.5598C113.092 54.4781 112.373 55.2225 111.486 55.2225C110.599 55.2225 109.88 54.4781 109.88 53.5598C109.88 52.6416 110.599 51.8971 111.486 51.8971C112.373 51.8971 113.092 52.6416 113.092 53.5598ZM47.3359 77.1496C43.551 78.6416 41.2137 80.4226 38.7021 83.3914C38.7021 79.9661 41.8243 76.929 45.5697 76.9291C47.3663 76.9292 47.3359 77.1496 47.3359 77.1496ZM121.789 77.5995C125.021 79.0297 127.017 80.7368 129.162 83.5827C129.162 80.2993 126.496 77.388 123.297 77.3881C121.763 77.3882 121.789 77.5995 121.789 77.5995ZM109.877 42.7015C109.877 44.1932 108.743 45.4024 107.343 45.4024C105.944 45.4024 104.81 44.1932 104.81 42.7015C104.81 41.2099 105.944 40.0007 107.343 40.0007C108.743 40.0007 109.877 41.2099 109.877 42.7015ZM106.991 49.5812C107.262 49.5812 107.482 49.3613 107.482 49.0899C107.482 48.8186 107.262 48.5986 106.991 48.5986C106.72 48.5986 106.5 48.8186 106.5 49.0899C106.5 49.3613 106.72 49.5812 106.991 49.5812ZM103.327 44.4574C103.327 45.1002 102.824 45.6214 102.203 45.6214C101.582 45.6214 101.078 45.1002 101.078 44.4574C101.078 43.8145 101.582 43.2933 102.203 43.2933C102.824 43.2933 103.327 43.8145 103.327 44.4574ZM72.6359 38.1021C73.3456 38.1021 73.921 37.5065 73.921 36.7719C73.921 36.0372 73.3456 35.4416 72.6359 35.4416C71.9262 35.4416 71.3508 36.0372 71.3508 36.7719C71.3508 37.5065 71.9262 38.1021 72.6359 38.1021ZM68.4979 41.7026C68.9192 41.7026 69.2607 41.3488 69.2607 40.9124C69.2607 40.4759 68.9192 40.1221 68.4979 40.1221C68.0766 40.1221 67.7351 40.4759 67.7351 40.9124C67.7351 41.3488 68.0766 41.7026 68.4979 41.7026ZM61.166 39.4308C61.166 40.1427 60.6085 40.7197 59.9207 40.7197C59.233 40.7197 58.6754 40.1427 58.6754 39.4308C58.6754 38.719 59.233 38.1419 59.9207 38.1419C60.6085 38.1419 61.166 38.719 61.166 39.4308ZM62.8798 45.4063C63.7006 45.4063 64.366 44.7176 64.366 43.8679C64.366 43.0182 63.7006 42.3295 62.8798 42.3295C62.0591 42.3295 61.3937 43.0182 61.3937 43.8679C61.3937 44.7176 62.0591 45.4063 62.8798 45.4063ZM61.8654 50.9622C61.8654 51.3984 61.5238 51.752 61.1025 51.752C60.6812 51.752 60.3397 51.3984 60.3397 50.9622C60.3397 50.5261 60.6812 50.1725 61.1025 50.1725C61.5238 50.1725 61.8654 50.5261 61.8654 50.9622ZM55.1909 50.2368C56.8546 50.2368 58.2032 48.8409 58.2032 47.119C58.2032 45.397 56.8546 44.0011 55.1909 44.0011C53.5272 44.0011 52.1786 45.397 52.1786 47.119C52.1786 48.8409 53.5272 50.2368 55.1909 50.2368ZM57.4127 56.5793C57.4127 57.6815 56.5498 58.575 55.4852 58.575C54.4207 58.575 53.5577 57.6815 53.5577 56.5793C53.5577 55.477 54.4207 54.5835 55.4852 54.5835C56.5498 54.5835 57.4127 55.477 57.4127 56.5793ZM46.6174 49.0872C47.1944 49.0872 47.6622 48.6033 47.6622 48.0064C47.6622 47.4096 47.1944 46.9257 46.6174 46.9257C46.0404 46.9257 45.5726 47.4096 45.5726 48.0064C45.5726 48.6033 46.0404 49.0872 46.6174 49.0872ZM54.1901 40.0244C54.1901 40.8048 53.5787 41.4375 52.8244 41.4375C52.0702 41.4375 51.4587 40.8048 51.4587 40.0244C51.4587 39.2439 52.0702 38.6112 52.8244 38.6112C53.5787 38.6112 54.1901 39.2439 54.1901 40.0244Z",
    fill: "url(#paint10_linear_14011_164658)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6205 83.9497C41.6205 83.9497 32.1115 98.7982 57.5141 111.477C82.577 124.02 102.104 116.766 113.515 110.935C119.322 107.985 125.809 100.663 127.235 94.1877C129.613 83.2039 120.002 76.7628 110.357 81.7122C102.172 85.9159 98.5924 86.775 87.2835 86.3343C67.9259 85.5885 64.2043 81.9835 54.4237 79.7799C52.9973 79.4409 51.7068 79.3053 50.5182 79.3053C43.8279 79.3053 41.6205 83.9497 41.6205 83.9497Z",
    fill: "url(#paint11_radial_14011_164658)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14011_164658",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 79,
    width: 89,
    height: 40
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6205 83.9497C41.6205 83.9497 32.1115 98.7982 57.5141 111.477C82.577 124.02 102.104 116.766 113.515 110.935C119.322 107.985 125.809 100.663 127.235 94.1877C129.613 83.2039 120.002 76.7628 110.357 81.7122C102.172 85.9159 98.5924 86.775 87.2835 86.3343C67.9259 85.5885 64.2043 81.9835 54.4237 79.7799C52.9973 79.4409 51.7068 79.3053 50.5182 79.3053C43.8279 79.3053 41.6205 83.9497 41.6205 83.9497Z",
    fill: "url(#paint12_radial_14011_164658)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14011_164658)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.8497 85.7089C85.294 87.8557 86.208 89.8607 87.4884 91.4375C89.8091 94.2935 93.4724 96.3049 96.4986 93.9447C98.5919 92.3129 99.6575 89.1936 99.4142 86.2316C99.3437 85.3626 99.2279 84.4771 99.0457 83.6299C96.3965 85.2924 93.3281 86.3504 89.2679 86.1575C87.6937 86.0821 86.2312 85.9236 84.8497 85.7089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.778 78.2207C113.778 78.2207 111.799 80.8395 111.075 79.5724C110.659 79.9063 108.518 80.2394 108.101 80.6537C104.014 84.7104 101.613 84.441 101.613 84.441C102.849 87.5706 104.575 89.978 106.514 91.2069C109.625 93.182 115.4 92.2787 115.941 87.1421C115.941 81.4649 115.098 82.1567 113.778 78.2207Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0885 83.0876C67.7127 83.518 67.203 84.3036 66.8873 84.9442C65.9257 87.6835 65.5473 91.3136 67.203 93.8823C68.6292 96.095 72.931 97.1199 75.9286 95.2532C79.96 91.9834 79.8577 87.2856 80.7948 84.9801C77.2803 84.9801 76.0752 84.9633 73.458 84.3211C73.458 84.3211 70.5216 83.6283 68.0885 83.0876Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9778 89.3055C56.6484 91.3212 53.7598 91.4207 51.5651 88.4282C49.8538 86.0959 49.8735 82.7472 51.239 80.3099C51.592 79.6788 51.9843 79.1694 52.414 78.7617C53.2494 78.8332 54.9588 79.1072 55.9226 79.3452C59.6972 80.2756 64.8441 82.2624 64.8441 82.2624C63.8658 84.2383 62.596 86.9957 59.9778 89.3055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.6276 82.8524C56.6609 79.2438 63.0635 83.1496 63.7633 84.4383C64.1505 83.9529 64.2814 83.3639 64.5744 82.8163C61.3444 80.5503 58.3442 80.5833 54.5697 79.721C53.6059 79.5005 52.7094 79.368 51.8729 79.3018C51.4443 79.6796 51.0519 80.1516 50.6989 80.7365C49.3334 82.9952 49.435 86.3308 51.025 88.26C52.1384 89.3046 51.5977 88.7639 52.9495 89.8453C51.8681 88.2232 49.6098 85.5521 52.6276 82.8524Z",
    fill: "#F5C5A9"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7094 107.618C80.7471 108.099 79.7314 108.634 78.68 108.474C78.1811 108.402 77.7177 108.171 77.2723 107.975C74.1003 106.549 70.5363 105.712 67.1684 106.513C63.9786 107.244 61.0739 109.685 60.379 112.839C81.0144 122.087 97.6761 118.042 108.885 113.124C106.746 109.329 102.826 106.478 98.5492 105.355C96.8742 104.91 95.1634 104.714 93.4349 104.714C89.4076 104.714 85.3447 105.819 81.7094 107.618Z",
    fill: "url(#paint13_radial_14011_164658)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.891 113.128C107.75 111.11 106.108 109.373 104.186 108.009C104.188 108.306 104.162 108.603 104.078 108.888C103.481 110.912 101.492 112.188 99.5385 112.989C97.1388 113.972 94.5651 114.523 91.9739 114.606C91.4097 114.623 90.8299 114.616 90.3051 114.409C88.8112 113.819 88.3805 111.965 88.0016 110.405C87.6227 108.845 86.7055 107.022 85.1009 107.032C85.4725 106.634 85.8431 106.234 86.2158 105.836C84.6671 106.307 83.1556 106.907 81.7125 107.62C80.7569 108.092 79.7403 108.626 78.6844 108.472C78.6823 108.472 78.6792 108.47 78.6771 108.47L82.2322 111.145C82.8958 111.645 83.5821 112.171 83.9538 112.914C84.3254 113.658 84.2716 114.682 83.6091 115.183C83.1132 115.558 82.433 115.546 81.8129 115.505C76.412 115.147 71.0763 113.827 66.1309 111.626C65.6454 111.409 65.1505 111.175 64.7851 110.788C63.9631 109.917 64.0583 108.429 64.8058 107.493C64.87 107.412 64.9559 107.358 65.0263 107.285C62.7611 108.418 60.9194 110.411 60.378 112.832C81.0116 122.079 97.675 118.043 108.891 113.128Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1377 110.285C84.2175 111.325 84.8335 112.573 85.1026 113.495C85.2414 113.958 85.3149 114.34 85.3418 114.608C85.3666 114.872 85.3811 115.021 85.3811 115.021C85.3811 115.021 85.0354 114.53 84.4701 113.823C83.9038 113.112 83.0911 112.224 82.1491 111.314C81.2018 110.408 80.2814 109.632 79.5474 109.096C78.8197 108.558 78.3155 108.232 78.3155 108.232C78.3155 108.232 78.4646 108.241 78.7296 108.255C78.9998 108.272 79.3839 108.33 79.8518 108.45C80.7846 108.683 82.0538 109.248 83.1377 110.285Z",
    fill: "#831434"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.1209,
    cy: 67.4195,
    rx: 46.2293,
    ry: 35.1451,
    fill: "url(#paint14_linear_14011_164658)",
    fillOpacity: 0.7
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.072 57.1329C101.072 66.0914 93.8101 73.3537 84.8516 73.3537C75.8932 73.3537 68.6309 66.0914 68.6309 57.1329C68.6309 48.1744 75.8932 40.9121 84.8516 40.9121C93.8101 40.9121 101.072 48.1744 101.072 57.1329Z",
    fill: "#89C072"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.4503 57.1326C99.4503 65.1945 92.9143 71.73 84.8516 71.73C76.789 71.73 70.2529 65.1945 70.2529 57.1326C70.2529 49.0707 76.789 42.5352 84.8516 42.5352C92.9143 42.5352 99.4503 49.0707 99.4503 57.1326Z",
    fill: "url(#paint15_radial_14011_164658)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.4475 56.8637C92.4475 61.2008 88.9313 64.7166 84.5939 64.7166C80.2564 64.7166 76.7402 61.2008 76.7402 56.8637C76.7402 52.5266 80.2564 49.0107 84.5939 49.0107C88.9313 49.0107 92.4475 52.5266 92.4475 56.8637Z",
    fill: "url(#paint16_radial_14011_164658)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.2666 56.8636C88.2666 58.8916 86.6219 60.5361 84.5945 60.5361C82.5632 60.5361 80.9185 58.8916 80.9185 56.8636C80.9185 54.8355 82.5632 53.1902 84.5945 53.1902C86.6219 53.1902 88.2666 54.8355 88.2666 56.8636Z",
    fill: "#2E2A49"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.782 64.7025C123.782 70.6749 118.94 75.5164 112.968 75.5164C106.996 75.5164 102.154 70.6749 102.154 64.7025C102.154 58.7302 106.996 53.8887 112.968 53.8887C118.94 53.8887 123.782 58.7302 123.782 64.7025Z",
    fill: "#89C072"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.701 64.7004C122.701 70.075 118.344 74.432 112.969 74.432C107.594 74.432 103.236 70.075 103.236 64.7004C103.236 59.3257 107.594 54.9688 112.969 54.9688C118.344 54.9688 122.701 59.3257 122.701 64.7004Z",
    fill: "url(#paint17_radial_14011_164658)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.573 64.5322C118.573 67.4236 116.229 69.7675 113.337 69.7675C110.446 69.7675 108.102 67.4236 108.102 64.5322C108.102 61.6408 110.446 59.2969 113.337 59.2969C116.229 59.2969 118.573 61.6408 118.573 64.5322Z",
    fill: "url(#paint18_radial_14011_164658)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M115.785 64.5331C115.785 65.8851 114.689 66.9814 113.337 66.9814C111.983 66.9814 110.886 65.8851 110.886 64.5331C110.886 63.1811 111.983 62.0842 113.337 62.0842C114.689 62.0842 115.785 63.1811 115.785 64.5331Z",
    fill: "#2E2A49"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.5496 64.6918C67.5496 70.6641 62.7081 75.5057 56.7357 75.5057C50.7634 75.5057 45.9219 70.6641 45.9219 64.6918C45.9219 58.7195 50.7634 53.8779 56.7357 53.8779C62.7081 53.8779 67.5496 58.7195 67.5496 64.6918Z",
    fill: "#89C072"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.4698 64.6916C66.4698 70.0662 62.1124 74.4232 56.7373 74.4232C51.3623 74.4232 47.0049 70.0662 47.0049 64.6916C47.0049 59.317 51.3623 54.96 56.7373 54.96C62.1124 54.96 66.4698 59.317 66.4698 64.6916Z",
    fill: "url(#paint19_radial_14011_164658)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.7987 64.5195C61.7987 67.4109 59.4545 69.7548 56.5629 69.7548C53.6713 69.7548 51.3271 67.4109 51.3271 64.5195C51.3271 61.6281 53.6713 59.2842 56.5629 59.2842C59.4545 59.2842 61.7987 61.6281 61.7987 64.5195Z",
    fill: "url(#paint20_radial_14011_164658)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0146 64.5223C59.0146 65.8743 57.9182 66.9707 56.5666 66.9707C55.2124 66.9707 54.1159 65.8743 54.1159 64.5223C54.1159 63.1703 55.2124 62.0734 56.5666 62.0734C57.9182 62.0734 59.0146 63.1703 59.0146 64.5223Z",
    fill: "#2E2A49"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14011_164658",
    x1: 27.6502,
    y1: 100.731,
    x2: 57.5244,
    y2: 93.3214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_14011_164658",
    x1: 94.156,
    y1: 115.87,
    x2: 113.28,
    y2: 115.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14011_164658",
    x1: 55.6311,
    y1: 115.869,
    x2: 74.7554,
    y2: 115.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_14011_164658",
    x1: 114.01,
    y1: 91.3221,
    x2: 143.884,
    y2: 98.7308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_14011_164658",
    x1: 32.9441,
    y1: 23.613,
    x2: 56.8933,
    y2: 23.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_14011_164658",
    x1: 49.2084,
    y1: 35.7557,
    x2: 35.1081,
    y2: 35.7557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D360"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_14011_164658",
    x1: 134.444,
    y1: 23.614,
    x2: 110.495,
    y2: 23.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_14011_164658",
    x1: 118.375,
    y1: 35.7557,
    x2: 132.475,
    y2: 35.7557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B452"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4D360"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_14011_164658",
    x1: 30.9654,
    y1: 22.0207,
    x2: 139.75,
    y2: 22.0207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_14011_164658",
    x1: 30.9658,
    y1: 35.1283,
    x2: 139.748,
    y2: 35.1283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF166"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24B34B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_14011_164658",
    x1: 38.7021,
    y1: 69.8217,
    x2: 129.162,
    y2: 69.8217,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BBD660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2CA64B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_14011_164658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.7317 98.843) scale(33.9607 15.1289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D3825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_14011_164658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(83.7317 98.843) scale(33.9607 15.1289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D3825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4F0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D0000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_14011_164658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.6319 111.545) scale(17.8199 6.54605)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF721B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE1622"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_14011_164658",
    x1: 85.1209,
    y1: 32.2744,
    x2: 84.8505,
    y2: 79.5757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_14011_164658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8518 57.1324) scale(14.5987 14.5974)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_14011_164658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.5935 56.8641) scale(7.85365 7.85295)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#99D5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00973B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_14011_164658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(112.969 64.7002) scale(9.73246 9.73163)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_14011_164658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.337 64.5325) scale(5.23576 5.2353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#99D5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00973B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_14011_164658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.7375 64.6915) scale(9.73246 9.73163)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6C6C6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_14011_164658",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.5626 64.5198) scale(5.23577 5.2353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#99D5B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00973B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterHandsUp0);
export default __webpack_public_path__ + "static/media/MonsterHandsUp0.888801dde64cd77f113a5a8c20094ae0.svg";
export { ForwardRef as ReactComponent };